import { object, optional, string } from 'zod';

import { SchoolMapper } from '@/shared/category/util';

export const BuildPublisherInfoSchema = object({
  publisher: optional(string()),
  customPublisher: optional(string()),
});

export type BuildPublisherInfoSchemaType = Zod.infer<
  typeof BuildPublisherInfoSchema
>;

export const CUSTOM_PUBLISHER_REQUIRED_MESSAGE =
  'Custom publisher is required' as const;

export const CUSTOM_PUBLISHER_MIN_LENGTH = 2;
export const CUSTOM_PUBLISHER_MAX_LENGTH = 15;

export const DynamicBuildPublisherInfoSchema = BuildPublisherInfoSchema.refine(
  d => {
    const dataset = d as BuildPublisherInfoSchemaType;
    const publisher = dataset.publisher;
    if (!SchoolMapper.isEtc(publisher)) return true;
    const customPublisher = dataset.customPublisher;
    if (!customPublisher) return false;
    return (
      customPublisher.trim().length >= CUSTOM_PUBLISHER_MIN_LENGTH &&
      customPublisher.trim().length <= CUSTOM_PUBLISHER_MAX_LENGTH
    );
  },
  CUSTOM_PUBLISHER_REQUIRED_MESSAGE,
);

/**
 * 출판사 정보에 대한 checking 포함
 */
export const getBuildPublisherInfoSchema = () => {
  return BuildPublisherInfoSchema;
};

export const getDynamicBuildPublisherInfoSchema = () => {
  return DynamicBuildPublisherInfoSchema;
};
